import { Box, Card, IconButton, Typography } from "@mui/material";
import { numberFormat } from "../../../utils/nunberFormat";
import JIFFY_BRANCH_STATISTIC_ICON from '../../../assets/images/jiffy_branch_statistic_icon.svg';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from "react-i18next";

interface Props {
    branchName: string;
    totalSale: number;
}

const CardBranch = ({
    branchName,
    totalSale
}: Props) => {
    const { t } = useTranslation("global");
    return <Card sx={{ boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)', pt: 2, pb: 2, pl: 4, pr: 4, borderRadius: '16px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <img src={JIFFY_BRANCH_STATISTIC_ICON} alt="" style={{
                width: 18,
                height: 18
            }} />
            {/* <IconButton>
                <MoreHorizIcon />
            </IconButton> */}
        </Box>
        <Box mt={2}>
            <Typography fontSize={18} fontWeight="bold">{branchName}</Typography>
            <Typography color="#919EAB">{t("saleReport_page.total sale")}: {numberFormat(totalSale)} {t("saleReport_page.kip")}</Typography>
        </Box>
    </Card>
}
export default CardBranch;